import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    inject,
    ChangeDetectionStrategy
} from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { BehaviorSubject, Subscription } from "rxjs";
import { KundorderTyp } from "~app/common/models/constants";
import { IValidationContext } from "~app/common/validation/IValidationContext";
import { IValidationScope } from "~app/common/validation/IValidationScope";
import { IKundorderDetailKundorder, IKundorderDetailKundorderrad, ILagerplats } from "../../models/kundorder-detail-model";
import { KundorderradEditComponent } from "../kundorderrad-edit/kundorderrad-edit.component";

@Component({
    selector: "rask-kundorderrad-create",
    templateUrl: "./kundorderrad-create.component.html",
    styleUrls: ["./kundorderrad-create.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [KundorderradEditComponent]
})
export class KundorderradCreateComponent implements OnInit {
    @Input() enableCommands = true;
    @Input() kundorder: IKundorderDetailKundorder;
    @Input() kundorderTyp: string;
    lagerplatser: BehaviorSubject<ILagerplats[]> = new BehaviorSubject([]);
    @Input() modalMode: any;
    model: IKundorderDetailKundorderrad;
    @Output() modelCreated = new EventEmitter<IKundorderDetailKundorderrad>();
    pushedSubsciption: Subscription;
    @Input() rootForm: UntypedFormGroup;
    title: string;
    validation: IValidationScope;
    validationContext: IValidationContext;

    private readonly translateService = inject(TranslateService);

    constructor() {
        this.initModel();
    }

    initModel() {
        this.model = {
            id: 0,
            balans: 0,
            handelssortiment: undefined,
            mottagningsplats: undefined,
            alternativaMottagningsplatser: [],
            alternativaHandelssortiment: [],
            kvantitet: undefined,
            periodFrom: new Date().toLocaleDateString("sv-SE"),
            periodTom: undefined,
            lagerplatser: undefined,
            manuellPaArbetsorder: false,
            egenskapskodX: false,
            ejVirkeskop: false,
            inmatningshandelssortiment: undefined,
            kommentar: undefined
        } as any;
    }

    initTexts() {
        switch (this.kundorderTyp) {
            case KundorderTyp.Kundorder:
                this.title = this.translateService.instant("KUNDORDER_DETAIL_TITLE_NEW_ORDERRAD");
                break;
            case KundorderTyp.Terminalorder:
                this.title = this.translateService.instant("TERMINALORDER_DETAIL_TITLE_NEW_ORDERRAD");
                break;
        }
    }

    ngOnInit(): void {
        this.initTexts();
        this.modelCreated.emit(this.model);
    }
}
